import { faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type CloseButtonProps = {
	onClose: () => void;
};

const CloseButton = ({ onClose }: CloseButtonProps) => {
	return (
		<div
			className="d-close-btn pointer"
			onClick={() => {
				onClose();
			}}
		>
			<FontAwesomeIcon icon={faClose} />
		</div>
	);
};

export default CloseButton;
